import React, { useState } from "react";
import moment from "moment";
import MediaContainer from "./MediaContainer";
import { useLocation } from "react-router-dom";
import { ReactComponent as RightArrow } from "assets/img/icons/right-arrow.svg";
import { useHistory } from "react-router-dom";
import { useGlobalContext } from "store/contexts/globalContext";
import PollListDetailMicrosoftTeams from "components/PollListDetailMicrosoftTeams";

export default ({ pollList, index }) => {
  const history = useHistory();
  const location = useLocation();
  const { user } = pollList;
  const { microsoftConfigureTab } = useGlobalContext();
  const [pollListDailog, setPollListDailog] = useState(false);

  const goToPollDetail = () => {
    if (!microsoftConfigureTab) {
      history.push({
        pathname: `${location.pathname}/${pollList.id}/detail`,
        state: { status: true },
      });

      return;
    }

    if (microsoftConfigureTab) {
      setPollListDailog(true);
    }
  };

  return (
    <>
      <ul className="poll-list-ul">
        <li kye={index} className="poll-list-li">
          <div
            onClick={goToPollDetail}
            className="poll-list-link"
            style={{ cursor: "pointer" }}
          >
            <div className="poll-list-link">
              <MediaContainer
                attachment={pollList.media}
                content={pollList.content}
                media_type={pollList.media_type_id}
              />
              <div className="poll-list-detail">
                <span className="poll-list-name question customScrollArea">
                  {pollList.content}
                </span>
                <span className="poll-list-name">
                  Created By:{" "}
                  <span className="name">
                    {user ? (user.full_name ? user.full_name : "") : ""}
                  </span>
                </span>
                <span className="poll-list-name">
                  End Date:{" "}
                  <span className="orange">
                    {moment(pollList.end_date).format("yyyy-MM-DD")}
                  </span>
                </span>
                <span className="poll-list-name">
                  Response:{" "}
                  <span className="orange">{`${
                    pollList.responses_count ? pollList.responses_count : 0
                  }/${
                    pollList.max_responses_count
                      ? pollList.max_responses_count
                      : 0
                  }`}</span>
                </span>
              </div>
            </div>
            <div className="edit-icons">
              <span className="icon-edit ms-1 ">
                <RightArrow style={{ width: "30px", fill: "#ffa500" }} />
              </span>
            </div>
          </div>
        </li>
      </ul>
      {pollListDailog && (
        <PollListDetailMicrosoftTeams
          pollIdd={pollList.id}
          pollStatus={{ status: true }}
          dialog={pollListDailog}
          setDialog={setPollListDailog}
        />
      )}
    </>
  );
};
